<template>
  <ModalSmall v-if="isVisible" :title="$t('label_view_details')" @close="closeModal">
    <TableDynamic
      :columns="columns"
      :rows="rows"
      :show-column-titles="false"
      :show-more-button="false"
      table-class="no-hover"
    />
  </ModalSmall>
</template>

<script setup lang="ts">
import { reduce } from 'lodash';

import TableDynamic from '@/components/shared/base/TableDynamic.vue';
import ModalSmall from '@/components/shared/composite/ModalSmall.vue';
import { FIELD_FORMAT_MAP, FIELD_LABEL_MAP } from '@/utils/constants/common';

const isVisible = defineModel<boolean>({
  required: true,
  default: false,
});

const props = withDefaults(
  defineProps<{
    selectedRow: Record<string, string>;
    labelMap?: Record<string, string>;
    formatMap?: Record<string, Function>;
  }>(),
  {
    selectedRow: () => ({}),
    labelMap: () => FIELD_LABEL_MAP,
    formatMap: () => FIELD_FORMAT_MAP,
  }
);

const { t } = useI18n();

const columns = [
  {
    label: t('label_detail_info'),
    key: 'label',
    type: 'text',
    class: 'width30 paddingleft',
  },
  { label: '', key: 'value', type: 'text', class: 'width70' },
];

const rows = computed(() => {
  return reduce(
    props.selectedRow,
    (acc: Record<string, any>[], val, key) => {
      if (props.labelMap[key]) {
        acc.push({
          label: t(props.labelMap[key]),
          value: props.formatMap[key] ? props.formatMap[key](val) : val,
          class: 'prewrap-data',
        });
      }
      return acc;
    },
    []
  );
});

const closeModal = () => {
  isVisible.value = false;
};
</script>

<style scoped lang="scss">
.content-wrap {
  display: flex;
  padding: 0.625rem 1.5rem;
  border-bottom: 1px solid var(--border-default);
  border-left: 1px solid var(--border-default);
  border-right: 1px solid var(--border-default);
}
.content {
  width: 50%;
  word-break: break-word;
}

::v-deep .table-wrapper {
  width: 100%;
}

::v-deep .dynamic-table {
  border-top: 1px solid var(--border-default);
  border-left: 1px solid var(--border-default);
  border-right: 1px solid var(--border-default);
  border-bottom: 1px solid var(--border-default);
  min-width: unset !important;
}

::v-deep.dynamic-table tr:hover {
  background-color: unset;
}

@media (max-width: 768px) {
  .group-section,
  .participants {
    padding: 0.5rem 1rem;
  }
}
</style>
